<template>
<cotainer>
  <v-card persistent>
    <v-card-title class="primary white--text">
      <span class="headline">{{ formTitle }}</span>
        <v-spacer></v-spacer>
      <v-btn outline @click="addProduct" class="white--text">
        <v-icon left dark>add</v-icon>
          NEW PRODUCT
      </v-btn>
      <v-btn outline @click="scanItem()" class="white--text">
        <v-icon left dark>qr_code_scanner</v-icon>
          SCAN
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12>
            <v-data-table :headers="getHeaders" :items="allItems" hide-actions class="elevation-1">
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.productName }}</td>
                <td class="text-xs-left" v-if="gstInvoice">{{ props.item.HSN_code }}</td>
                <td v-if="gstInvoice">{{ props.item.taxableGST_rate }}</td>
                <td>{{ props.item.rate }}</td>
                <td>{{ props.item.unit }}</td>
                <td>{{ props.item.quantity }}</td>
                <td>{{ props.item.basicPrice }}</td>
                 <td v-if="gstInvoice">{{ props.item.GSTValue }}</td>
                <td>{{ props.item.tradeDiscount }}</td>
                <td>{{ props.item.totlePrice }}</td>
                <td v-if="gstInvoice">{{ props.item.CGST_val}} ₹ ({{props.item.CGST}} %)</td>
                <td v-if="gstInvoice">{{ props.item.SGST_val}} ₹ ({{props.item.SGST}} %)</td>
                <td v-if="gstInvoice">{{ props.item.IGST_val}} ₹ ({{props.item.IGST}} %)</td>
                <td class="justify-center layout px-0">
                  <v-btn icon class="mx-0" @click="editItem(props.item)">
                    <v-icon color="teal">edit</v-icon>
                  </v-btn>
                  <v-btn icon class="mx-0" @click="deleteItem(props.item)">
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                </td>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
          </v-flex>
          <v-flex xs12 sm5 md5>
            <v-select
              v-model="item.productName"
              @change="productChange"
              :items="productsByBrand"
              item-text="name"
              return-object
              autocomplete
              label="Products"
            />
          </v-flex>
          <v-flex xs12 sm1 md1>
            <v-text-field v-if="item.productName" type="number" :value="selectedProduct.quantity" :disabled="true" label="Available Quantity"></v-text-field>
          </v-flex>
          <!-- <v-flex xs12 sm6 md2>
            <v-text-field
              type="number"
              disabled
              v-if="item.productName"
              v-model.number="item.taxableGST_rate"
              suffix="%"
              label="GST"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field type="text" v-if="item.productName" disabled v-model.number="item.HSN_code" label="HSN Code"></v-text-field>
          </v-flex> -->
          <v-flex xs12 sm6 md2>
            <v-select 
              :items="units" label="Unit"  v-model="item.unit">
            </v-select>
          </v-flex>
          
          <v-flex xs12 sm6 md2>
            <v-text-field v-if="item.productName" type="number" v-model.number="item.quantity" label="Quantity"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field v-if="item.productName" type="number" v-model.number="item.rate" label="Product Rate"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field 
              v-if="item.productName && item.quantity && item.rate"
              type="number" 
              disabled 
              v-model.number="item.basicPrice" 
              label="Basic Price">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field
              v-if="item.productName && item.quantity && item.rate" 
              type="number" 
              disabled 
              v-model.number="item.GSTValue" 
              label="GST Value">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field
              v-if="item.productName && item.quantity && item.rate"
              type="number"
              disabled
              v-model.number="item.totlePrice"
              label="Total Price"
            ></v-text-field>
          </v-flex>
           <v-flex xs12 sm6 md4>
            <v-text-field
              v-if="item.productName && item.quantity && item.rate"
              type="text"
              v-model.number="item.batchNumber"
              label="Batch number"
              :disabled="isBuyer"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4  v-if="item.productName && item.quantity && item.rate">
              <v-menu
                :close-on-content-click="false"
                v-model="datepickerExp"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="item.expiryDate"
                  label="Expiry date"
                  prepend-icon="event"
                  :disabled="isBuyer"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="item.expiryDate" @input="datepickerExp = false"></v-date-picker>
              </v-menu>
          </v-flex>
          <v-flex xs12 sm6 md4  v-if="item.productName && item.quantity && item.rate">
              <v-menu
                :close-on-content-click="false"
                v-model="datepickerMen"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="item.manufacturingDate"
                  label="Manufacturing date"
                  prepend-icon="event"
                  :disabled="isBuyer"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="item.manufacturingDate" @input="datepickerMen = false"></v-date-picker>
              </v-menu>
          </v-flex>
           <v-flex xs12 sm6 md4>
            <v-switch
              v-if="item.productName && item.quantity && item.rate" 
              v-model="isTradePercentage"
              :label="`Trade Discount in: ${isTradePercentage ? '%' : '₹'}`"
            ></v-switch>
          </v-flex>
           <v-flex xs12 sm6 md4>
            <v-text-field
              v-if="item.productName && item.quantity && item.rate && isTradePercentage" 
              type="number"
              @keyup="calculateTradeDiscount()" 
              suffix="%"
              v-model.number="tradeDiscountPercentage" 
              label="Trade Discount">
            </v-text-field>
          </v-flex>
           <v-flex xs12 sm6 md4>
            <v-text-field
              v-if="item.productName && item.quantity && item.rate" 
              type="number" 
              suffix="₹"
              :disabled="isTradePercentage"
              v-model.number="item.tradeDiscount"
              label="Trade Discount">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
          <v-select
              v-if="item.productName && item.quantity && item.rate"
               dense
               :items="godawnByBrand"
               label="Via Godawn"
               v-model="item.godawnBy"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color="blue darken-1" @click.native="close">Cancel</v-btn>
      <v-spacer></v-spacer>
      <v-btn class="grey darken-1" @click.native="close">Back</v-btn>
      <v-btn class="primary white--text" :disabled="!(item.productName && item.quantity && item.rate)" @click.native="save(false)">Save</v-btn>
      <v-btn color="success white--text" :disabled="!(item.productName && item.quantity && item.rate)" @click.native="save(true)">Save & Add Another item</v-btn>
    </v-card-actions>
  </v-card>
    <v-dialog v-model="addProductDialog" fullscreen hide-overlay>
      <v-card>
        <v-card-title class="primary white--text">
          <span class="headline">Product Details</span>
          <v-spacer />
          <v-btn icon dark @click.native="addProductDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <!-- <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field type="text" v-model="currentProduct.name" label="Product Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-textarea
                  name="input-7-1"
                  outlined
                  label="Product Description"
                  v-model="currentProduct.description"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-select
                  dense
                  :items="GST_types"
                  label="Select GST type"
                  v-model="currentProduct.GST_type"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 md4>
                 <v-select
                  dense
                  :items="[0,5,12,18,28]"
                  v-model="currentProduct.taxableGST_rate"
                  :disabled="currentProduct.GST_type != 'TAXABLE'"
                  label="Taxable GST rate"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field type="number" v-model="currentProduct.HSN_code" label="HSN code"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-select dense :items="units" label="Select unit" v-model="currentProduct.unit"></v-select>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field type="number" v-model="currentProduct.quantity" label="Quantity"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field type="number" v-model="currentProduct.purchasingPrice" label="Purchasing Price"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field type="number" v-model="currentProduct.sellingPrice" label="Selling Price"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field type="number" v-model="currentProduct.purchasingPricePerProduct" label="Purchasing Price/Product"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field type="number" v-model="currentProduct.openingBalance" label="Opening Balance"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>-->
          <v-stepper v-model="stepper" vertical>
            <v-stepper-step :complete="stepper > 1" step="1">Step : 1 <h3 class = "error--text text--darken-4">{{duplicateError}}</h3></v-stepper-step>
            
            <v-stepper-content step="1">
              <v-card class="mb-12" style="height:100%">
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                        <v-combobox
                          v-model="currentProduct.name"
                          :items="productsByBrand"
                          :return-object="false"
                          item-text="name"
                          item-value="name"
                          @change="duplicateCheck()"
                          label="Product Name"
                          placeholder="Enter Product name"
                        ></v-combobox>
                        <!-- <v-text-field
                          type="text"
                          v-model="currentProduct.name"
                          @change="duplicateCheck()"
                          label="Product Name"
                        ></v-text-field> -->
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          type="text"
                          label="Product Description"
                          v-model="currentProduct.description"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-select
                          type="number"
                          dense
                          :items="GST_types"
                          label="Select GST type"
                          v-model="currentProduct.GST_type"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-select
                          dense
                          :items="[3,5,12,18,28]"
                          v-model="currentProduct.taxableGST_rate"
                          :disabled="currentProduct.GST_type != 'TAXABLE'"
                          label="Taxable GST rate"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          type="number"
                          v-model="currentProduct.HSN_code"
                          label="HSN code"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-select
                          dense
                          :items="units"
                          label="Select unit"
                          v-model="currentProduct.unit"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-btn color="primary" @click="stepper = 2">Next</v-btn>
                </v-card-text>
              </v-card>
            </v-stepper-content>

            <v-stepper-step :complete="stepper > 2" step="2">Step : 2</v-stepper-step>

            <v-stepper-content step="2">
              <v-card class="mb-12" style="height:100%">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <v-select
                        dense
                        :items="[
                          {
                            text: 'Yes',
                            value: true
                          },
                          {
                            text: 'No',
                            value: false
                          },
                          ]"
                        label="Do you have Opening Balance Of Product?"
                        v-model="isOpeningBalance"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap v-if="isOpeningBalance">
                    <v-flex xs12 sm6 md6 v-if="isOpeningBalance">
                        <v-menu
                          :close-on-content-click="false"
                          v-model="datepicker"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            v-model="currentProduct.openingDate"
                            label="Date"
                            prepend-icon="event"
                            readonly
                          ></v-text-field>
                          <v-date-picker v-model="currentProduct.openingDate" @input="datepicker = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="number"
                        v-model="currentProduct.quantity"
                        label="Opening Quantity"
                      ></v-text-field>
                    </v-flex>
                    
                    <v-flex xs12 sm4 md4>
                      <v-text-field
                        type="number"
                        v-model="currentProduct.openingBalance"
                        label="Opening Amount"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm4 md4>
                      <v-text-field
                        :disabled="true"
                        type="number"
                        :value="(Number.parseFloat((currentProduct.openingBalance * 100) / (currentProduct.taxableGST_rate + 100))).toFixed(2) "
                        label="Basic Value"
                      ></v-text-field>
                    </v-flex>
                    
                    <v-flex xs12 sm4 md4>
                      <v-text-field
                        :disabled="true"
                        type="number"
                        :value="(Number.parseFloat ((currentProduct.openingBalance || 0) - ((currentProduct.openingBalance * 100) / (currentProduct.taxableGST_rate + 100)))).toFixed(2) "
                        label="GST Value"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-card-text>
                  <v-btn color="primary" @click="stepper = 3">Next</v-btn>
                  <v-btn text @click="stepper = 1">Back</v-btn>
                </v-card-text>
              </v-card>
            </v-stepper-content>

            <v-stepper-step :complete="stepper > 3" step="3">Step : 3</v-stepper-step>

            <v-stepper-content step="3">
              <v-card class="mb-12" style="height:100%">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        dense
                        :items="[
                          {
                            text: 'Yes',
                            value: true
                          },
                          {
                            text: 'No',
                            value: false
                          },
                        ]"
                        label="Do you want to add Standard Price of the Product?"
                        v-model="isStanderedPrice"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4 v-if="isStanderedPrice">
                      <v-select
                        dense
                        :disabled="true"
                        :items="units"
                        label="Select unit"
                        v-model="currentProduct.unit"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4 v-if="isStanderedPrice">
                        <v-select
                          dense
                          :items="[3,5,12,18,28]"
                          v-model="currentProduct.taxableGST_rate"
                          :disabled="true"
                          label="Taxable GST rate"
                        ></v-select>
                      </v-flex>
                  </v-layout>
                  <v-layout wrap v-if="isStanderedPrice">
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="number"
                        v-model="currentProduct.purchasingPrice"
                        label="Purchasing Price [Excluding GST]"
                      ></v-text-field>
                    </v-flex>
                     <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="number"
                        :disabled="true"
                        :value="currentProduct.taxableGST_rate ? (Number.parseFloat((currentProduct.purchasingPrice * currentProduct.taxableGST_rate)/100) + Number.parseFloat(currentProduct.purchasingPrice)).toFixed(2) : currentProduct.purchasingPrice"
                        label="Purchasing Price [Including GST]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="number"
                        v-model="currentProduct.sellingPrice"
                        label="Selling Price [Excluding GST]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="number"
                        :disabled="true"
                        :value="currentProduct.taxableGST_rate ? (Number.parseFloat((currentProduct.sellingPrice * currentProduct.taxableGST_rate)/100) + Number.parseFloat(currentProduct.sellingPrice)).toFixed(2) : currentProduct.sellingPrice"
                        label="Selling Price [Including GST]"
                      ></v-text-field>
                    </v-flex>
                   
                  </v-layout>
                </v-container>
                <v-card-text>
                  <v-btn text @click="stepper = 2">Back</v-btn>
                  <v-btn color="primary" @click="saveProduct" v-if="!currentProduct['.key']">Save</v-btn>
                  <v-btn
                    color="primary"
                    @click="updateProduct"
                    v-if="!!currentProduct['.key']"
                  >Update</v-btn>
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="scannerDialog" persistent max-width="800px">
         <v-card>
        <v-card-title class="primary white--text">
          <span class="headline">Scan Barcode of Product</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
             <section id="container" class="container">
                <label>
                    <span>Camera</span>
                    <select name="input-stream_constraints" id="deviceSelection">
                    </select>
                </label>
                 <div id="interactive" class="viewport"></div>
             </section>
          </v-container>
        </v-card-text>
        
           <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="scannerDialog = false">Cancel</v-btn>
        </v-card-actions>
         </v-card>
      </v-dialog>
    <v-snackbar :timeout="timeout" top v-model="snackbar" color="primary">
    Product is added.
    </v-snackbar>
</cotainer>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import { json } from "body-parser";

const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];

export default {
  props: {
    buyerId: String,
    isEditItems : Boolean,
     gstInvoice : Boolean,
    allItems : Array,
    editedItem: {
      type: Object,
      default: function() {
        return {
          productName: "",
          productId: "",
          HSN_code: "",
          taxableGST_rate: 0,
          rate: 0,
          unit: "",
          quantity: 0,
          basicPrice: 0,
          GSTValue: 0,
          totlePrice: 0,
          GST_type : "",
          productUnit : '',
          tradeDiscount : 0,
          expiryDate : new Date(new Date().setFullYear(new Date().getFullYear()+100)).toISOString().substr(0, 10),
          manufacturingDate : new Date(new Date().setFullYear(new Date().getFullYear()+100)).toISOString().substr(0, 10),
          batchNumber : 'DEFAULT'
        };
      }
    }
  },
  data() {
    return {
      headers: [
        { text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" },
        { text: "HSN code", sortable: false, value: "HSN_code", class: "font-weight-bold primary--text" },
        { text: "GST", sortable: false, value: "taxableGST_rate", class: "font-weight-bold primary--text" },
        { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" },
        { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" },
        { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" },
        { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" },
        { text: "GST value", sortable: false, value: "GSTValue",  class: "font-weight-bold primary--text" },
        { text: "Trade Discount", sortable: false, value: "totlePrice",  class: "font-weight-bold primary--text" },
        { text: "Total Price", sortable: false, value: "totlePrice",  class: "font-weight-bold primary--text" },
        { text: "CGST value ( %)", sortable: false, value: "CGST",  class: "font-weight-bold primary--text" },
        { text: "SGST value ( %)", sortable: false, value: "SGST",  class: "font-weight-bold primary--text" },
        { text: "IGST value ( %)", sortable: false, value: "IGST",  class: "font-weight-bold primary--text" },
        { text: "", value: "name", sortable: false }
      ],
      isBuyer : null,
      isTradePercentage:false,
      scannerDialog:false,
      tradeDiscountPercentage : null,
      item: this.editedItem,
      products: [],
      selectedProduct: {},
      stepper: 1,
      isOpeningBalance: false,
      isStanderedPrice: false,
      addProductDialog: false,
      datepicker : false,
      snackbar : false,
      productChanged : false,
      duplicateError : null,
      timeout : 3000,
      datepickerExp : null,
      datepickerMen : null,
      GST_types: [
        {
          text: "Exempt",
          value: "EXEMPT"
        },
        {
          text: "Nil Rated",
          value: "NILL"
        },
        {
          text: "Taxable",
          value: "TAXABLE"
        },
        {
          text: "Non-GST",
          value: "OTHER"
        }
      ],
      currentProduct: {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        unit: "",
        quantity: 0,
        brand: "",
        openingDate : new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue : 0,
        basicPrice : 0
      },
    };
  },
  watch: {
    editedItem(val) {
      this.item = this.editedItem;
      console.log(this.item)
    },
    "item.rate": {
      handler(newVal, oldVal) {
        this.calculatePrices();
      },
      deep: true
    },
    "item.tradeDiscount": {
      handler(newVal, oldVal) {
        this.calculatePrices();
      },
      deep: true
    },
    "item.quantity": {
      handler(newVal, oldVal) {
        this.calculatePrices();
      },
      deep: true
    },
    "item.unit": {
      handler(newVal, oldVal) {
        // this.productChange(this.selectedProduct);
      },
      deep: true
    },
    "currentProduct.GST_type": {
      handler(newVal, oldVal) {
        if (newVal != "TAXABLE") {
          this.currentProduct.taxableGST_rate = 0;
        }
      },
      deep: true
    },
     "currentProduct.basicPrice": {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },
      deep: true
    },
    "currentProduct.gstValue": {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },
      deep: true
    }
  },
  created() {
    this.$bindAsArray("rate", this.$root.$firebaseRefs.rate.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject('buyerById', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("batch", this.$root.$firebaseRefs.batchTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand))
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","finYear"]),
    ...mapGlobalGetters({ units: "productUnit" }),
    productsByBrand() {
      if (this.rate) {
        return this.products.filter(
          item => (item["brand"] === this.selectedBrand  &&
          (!this.gstInvoice ? item.GST_type !='TAXABLE' : true) &&
           (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true))
        );
      }
    },
    godawnByBrand() {
      return this.godawns
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand 
          );
        })
        .map(item => {
          return {
            text: item["godawnName"],
            value: item[".key"]
          };
        });
    },
    getHeaders(){
       if(this.gstInvoice) {
          return [
          { text: "Name", sortable: false, value: "productName" , class: "font-weight-bold primary--text" },
          { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" },
          { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" },
          { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" },
          { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" },
          { text: "GST value", sortable: false, value: "GSTValue", class: "font-weight-bold primary--text" },
          { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" },
          { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text", },
          { text: "CGST ", sortable: false, value: "CGST", class: "font-weight-bold primary--text" },
          { text: "SGST ", sortable: false, value: "SGST", class: "font-weight-bold primary--text" },
          { text: "IGST ", sortable: false, value: "IGST", class: "font-weight-bold primary--text" },
          { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" },
          { text: "", value: "name", sortable: false }
        ]
      }
      else {
        return [
          { text: "Name", sortable: false, value: "productName" , class: "font-weight-bold primary--text" },
          { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" },
          { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" },
          { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" },
          { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" },
          { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" },
          { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text", },
          { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" },
          { text: "", value: "name", sortable: false }
        ]
      }
    },
    formTitle() {
      return this.editedIndex === -1 ? "Edit Item" : "New Item";
    }
  },

  methods: {
    close() {
      this.$emit("closeAddItem",false);
      this.reset();
    },
    editItem(item) {
      this.reset();
       this.$emit("editItem",item,true);
    },
    deleteItem(item){
      this.reset();
      this.$emit("deleteItem",item);
    },
    productChange(val) {
      this.selectedProduct = val;
      let buyer = this.buyerById[this.buyerId];
      let isBuyer = buyer  ? true : false;
      this.item.productId = val[".key"];
      this.item.HSN_code = val["HSN_code"];
      this.item.taxableGST_rate = val["taxableGST_rate"];
      this.item.unit = val["unit"];

      // console.log(JSON.stringify(this.selectedProduct.unit))
      // console.log(JSON.stringify(this.item.unit))
        if(this.selectedProduct.unit == this.item.unit) {
          this.item.rate = isBuyer ? val["sellingPrice"] : val["purchasingPrice"]
          // console.log(val["purchasingPrice"])
          // console.log( val["sellingPrice"])
        }
        if(isBuyer) {
          this.getProductBatch();
        }
      this.productChanged = true; 
    },
    calculateTradeDiscount(){
      this.item.tradeDiscount = Number.parseFloat((this.tradeDiscountPercentage * this.item.rate * this.item.quantity)/100).toFixed(2);
    },
    calculatePrices() {
      if(this.isBuyer == null) {
          let buyer = this.buyerById[this.buyerId];
          this.isBuyer = buyer  ? true : false;
      }
      this.item.basicPrice = (Number.parseFloat(
        this.item.rate * this.item.quantity) - Number.parseFloat(this.item.tradeDiscount)).toFixed(2);
      this.item.GSTValue = Number.parseFloat(
        this.item.basicPrice * (parseFloat(this.item.taxableGST_rate)/100)).toFixed(2);
      this.item.totlePrice = Number.parseFloat(
        (Number.parseFloat(this.item.basicPrice) + Number.parseFloat(this.item.GSTValue))).toFixed(2);
    },
    getProductBatch(){
      let batchArray = this.batch.filter((item) => {
        return (item['brand'] === this.selectedBrand &&
          item['product'] === this.selectedProduct['.key']
          )
      });
      batchArray.sort(function(a,b){
        return -(new Date(b.expiryDate) - new Date(a.expiryDate));
      });
      console.log(batchArray)
      if(batchArray.length) {
        this.item.batchNumber = batchArray[0].batchNumber
        // this.item.expiryDate = new Date(batchArray[0].expiryDate).toISOString().substr(0, 10);
        // this.item.manufacturingDate = new Date(batchArray[0].manufacturingDate).toISOString().substr(0, 10);
        this.item.expiryDate = batchArray[0].expiryDate ? new Date(batchArray[0].expiryDate).toISOString().substr(0, 10) :
        new Date(new Date().setFullYear(new Date().getFullYear()+100)).toISOString().substr(0, 10);
        this.item.manufacturingDate = batchArray[0].manufacturingDate ? new Date(batchArray[0].manufacturingDate).toISOString().substr(0, 10) :
        new Date(new Date().setFullYear(new Date().getFullYear()+100)).toISOString().substr(0, 10);
      } else {
        this.item.expiryDate = new Date(new Date().setFullYear(new Date().getFullYear()+100)).toISOString().substr(0, 10);
        this.item.manufacturingDate = new Date(new Date().setFullYear(new Date().getFullYear()+100)).toISOString().substr(0, 10);
        this.item.batchNumber = 'DEFAULT';
      }
    },
    save(saveAndAdd) {
      let buyer = this.buyerById[this.buyerId];
      let isBuyer = buyer  ? true : false;
      // if(!this.isBuyer) {
      //   this.item.expiryDate = new Date(this.item.expiryDate).getTime(),
      //   this.item.manufacturingDate = new Date(this.item.manufacturingDate).getTime()
      // }
      if(this.item.quantity > this.selectedProduct.quantity && isBuyer) {
        if(confirm("stock can go in negative - do you want to proceed ?")) {
          if(!this.isEditItems || (this.isEditItems && this.productChanged)) {
            this.item.productName = this.selectedProduct.name;
            this.item.GST_type = this.selectedProduct.GST_type;
            this.item.productUnit = this.selectedProduct.unit;
            this.item.availableQuantity = this.selectedProduct.quantity
          }
          this.$emit('saveAddItem', this.item,saveAndAdd)
          this.reset()
        }
      } else {
        if(!this.isEditItems || (this.isEditItems && this.productChanged)) {
          this.item.productName = this.selectedProduct.name;
          this.item.GST_type = this.selectedProduct.GST_type;
          this.item.productUnit = this.selectedProduct.unit;
          this.item.availableQuantity = this.selectedProduct.quantity
        }
        this.$emit('saveAddItem', this.item,saveAndAdd)
        this.reset()
      }
    },
    reset() {
      this.item = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        GST_type : "",
        productUnit : '',
        totlePrice: 0,
        tradeDiscount : 0,
      };
      this.productChanged = false;
      this.tradeDiscountPercentage = null;
      this.isTradePercentage = false;
    },
     duplicateCheck(){
       let duplicateCheck = this.products.filter(
        item => item["brand"] === this.selectedBrand
        && item['name'] == this.currentProduct.name
      );
      if(duplicateCheck.length) {
          this.duplicateError = 'Product with name ' + this.currentProduct.name + ' Already exist.';
                setTimeout(() => {
                    this.duplicateError = null;
          }, 3000);
      }
    },
    saveProduct() {
      let duplicateCheck = this.products.filter(
        item => item["brand"] === this.selectedBrand
        && item['name'] == this.currentProduct.name
      );
      // console.log(duplicateCheck)
      if(duplicateCheck.length) {
          this.duplicateError = 'Product with name ' + this.currentProduct.name + ' Already exist.';
                setTimeout(() => {
                    this.duplicateError = null;
          }, 3000);
      } else {
        this.currentProduct["brand"] = this.selectedBrand;
        this.currentProduct["HSN_code"] = Number.parseFloat(
          this.currentProduct.HSN_code
        );
        this.currentProduct["taxableGST_rate"] = Number.parseFloat(
          this.currentProduct.taxableGST_rate
        );
        this.currentProduct.purchaseQuantity = 0;
        this.currentProduct.saleQuantity = 0;
        this.currentProduct.openingQuantity = this.currentProduct.quantity;
        this.currentProduct.openingDate = new Date(this.currentProduct.openingDate).getTime()
        this.$root.$firebaseRefs.products.push(this.currentProduct);
        this.addProductDialog = false;
        this.snackbar = true;
      }
    },
    addProduct() {
      this.stepper = 1;
      this.currentProduct = {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        unit: "",
        quantity: 0,
        openingDate : new Date().toISOString().substr(0, 10),
        brand: "",
        basicPrice : 0,
        gstValue : 0,
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        purchasingPricePerProduct: null
      };
      this.addProductDialog = true;
    },
    calculateOpeningBalance() {
      this.currentProduct.openingBalance = Number.parseFloat(this.currentProduct.basicPrice) + Number.parseFloat(this.currentProduct.gstValue);
    },
    scanItem(){
      this.scannerDialog = true;
      this.initQugga();
    },
    initQugga(){
    let selfVue = this;
          $(function() {
    var resultCollector = Quagga.ResultCollector.create({
        capture: true,
        capacity: 20,
        blacklist: [{
            code: "WIWV8ETQZ1", format: "code_93"
        }, {
            code: "EH3C-%GU23RK3", format: "code_93"
        }, {
            code: "O308SIHQOXN5SA/PJ", format: "code_93"
        }, {
            code: "DG7Q$TV8JQ/EN", format: "code_93"
        }, {
            code: "VOFD1DB5A.1F6QU", format: "code_93"
        }, {
            code: "4SO64P4X8 U4YUU1T-", format: "code_93"
        }],
        filter: function(codeResult) {
            // only store results which match this constraint
            // e.g.: codeResult
            return true;
        }
    });
    var App = {
        init: function() {
            var self = this;

            Quagga.init(this.state, function(err) {
                if (err) {
                    return self.handleError(err);
                }
                //Quagga.registerResultCollector(resultCollector);
                App.attachListeners();
                App.checkCapabilities();
                Quagga.start();
            });
        },
        handleError: function(err) {
            console.log(err);
        },
        checkCapabilities: function() {
            var track = Quagga.CameraAccess.getActiveTrack();
            var capabilities = {};
            if (typeof track.getCapabilities === 'function') {
                capabilities = track.getCapabilities();
            }
            this.applySettingsVisibility('zoom', capabilities.zoom);
            this.applySettingsVisibility('torch', capabilities.torch);
        },
        updateOptionsForMediaRange: function(node, range) {
            console.log('updateOptionsForMediaRange', node, range);
            var NUM_STEPS = 6;
            var stepSize = (range.max - range.min) / NUM_STEPS;
            var option;
            var value;
            while (node.firstChild) {
                node.removeChild(node.firstChild);
            }
            for (var i = 0; i <= NUM_STEPS; i++) {
                value = range.min + (stepSize * i);
                option = document.createElement('option');
                option.value = value;
                option.innerHTML = value;
                node.appendChild(option);
            }
        },
        applySettingsVisibility: function(setting, capability) {
            // depending on type of capability
            if (typeof capability === 'boolean') {
                var node = document.querySelector('input[name="settings_' + setting + '"]');
                if (node) {
                    node.parentNode.style.display = capability ? 'block' : 'none';
                }
                return;
            }
            if (window.MediaSettingsRange && capability instanceof window.MediaSettingsRange) {
                var node = document.querySelector('select[name="settings_' + setting + '"]');
                if (node) {
                    this.updateOptionsForMediaRange(node, capability);
                    node.parentNode.style.display = 'block';
                }
                return;
            }
        },
        initCameraSelection: function(){
            var streamLabel = Quagga.CameraAccess.getActiveStreamLabel();

            return Quagga.CameraAccess.enumerateVideoDevices()
            .then(function(devices) {
                function pruneText(text) {
                    return text.length > 30 ? text.substr(0, 30) : text;
                }
                var $deviceSelection = document.getElementById("deviceSelection");
                while ($deviceSelection.firstChild) {
                    $deviceSelection.removeChild($deviceSelection.firstChild);
                }
                devices.forEach(function(device) {
                    var $option = document.createElement("option");
                    $option.value = device.deviceId || device.id;
                    $option.appendChild(document.createTextNode(pruneText(device.label || device.deviceId || device.id)));
                    $option.selected = streamLabel === device.label;
                    $deviceSelection.appendChild($option);
                });
            });
        },
        attachListeners: function() {
            var self = this;

            self.initCameraSelection();
            $(".controls").on("click", "button.stop", function(e) {
                e.preventDefault();
                Quagga.stop();
                self._printCollectedResults();
            });

            $(".controls .reader-config-group").on("change", "input, select", function(e) {
                e.preventDefault();
                var $target = $(e.target),
                    value = $target.attr("type") === "checkbox" ? $target.prop("checked") : $target.val(),
                    name = $target.attr("name"),
                    state = self._convertNameToState(name);

                console.log("Value of "+ state + " changed to " + value);
                self.setState(state, value);
            });
        },
        _printCollectedResults: function() {
            var results = resultCollector.getResults(),
                $ul = $("#result_strip ul.collector");

            results.forEach(function(result) {
                var $li = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');

                $li.find("img").attr("src", result.frame);
                $li.find("h4.code").html(result.codeResult.code + " (" + result.codeResult.format + ")");
                $ul.prepend($li);
            });
        },
        _accessByPath: function(obj, path, val) {
            var parts = path.split('.'),
                depth = parts.length,
                setter = (typeof val !== "undefined") ? true : false;

            return parts.reduce(function(o, key, i) {
                if (setter && (i + 1) === depth) {
                    if (typeof o[key] === "object" && typeof val === "object") {
                        Object.assign(o[key], val);
                    } else {
                        o[key] = val;
                    }
                }
                return key in o ? o[key] : {};
            }, obj);
        },
        _convertNameToState: function(name) {
            return name.replace("_", ".").split("-").reduce(function(result, value) {
                return result + value.charAt(0).toUpperCase() + value.substring(1);
            });
        },
        detachListeners: function() {
            $(".controls").off("click", "button.stop");
            $(".controls .reader-config-group").off("change", "input, select");
        },
        applySetting: function(setting, value) {
            var track = Quagga.CameraAccess.getActiveTrack();
            if (track && typeof track.getCapabilities === 'function') {
                switch (setting) {
                case 'zoom':
                    return track.applyConstraints({advanced: [{zoom: parseFloat(value)}]});
                case 'torch':
                    return track.applyConstraints({advanced: [{torch: !!value}]});
                }
            }
        },
        setState: function(path, value) {
            var self = this;

            if (typeof self._accessByPath(self.inputMapper, path) === "function") {
                value = self._accessByPath(self.inputMapper, path)(value);
            }

            if (path.startsWith('settings.')) {
                var setting = path.substring(9);
                return self.applySetting(setting, value);
            }
            self._accessByPath(self.state, path, value);

            console.log(JSON.stringify(self.state));
            App.detachListeners();
            Quagga.stop();
            App.init();
        },
        inputMapper: {
            inputStream: {
                constraints: function(value){
                    if (/^(\d+)x(\d+)$/.test(value)) {
                        var values = value.split('x');
                        return {
                            width: {min: parseInt(values[0])},
                            height: {min: parseInt(values[1])}
                        };
                    }
                    return {
                        deviceId: value
                    };
                }
            },
            numOfWorkers: function(value) {
                return parseInt(value);
            },
            decoder: {
                readers: function(value) {
                    if (value === 'ean_extended') {
                        return [{
                            format: "ean_reader",
                            config: {
                                supplements: [
                                    'ean_5_reader', 'ean_2_reader'
                                ]
                            }
                        }];
                    }
                    return [{
                        format: value + "_reader",
                        config: {}
                    }];
                }
            }
        },
        state: {
            inputStream: {
                type : "LiveStream",
                constraints: {
                    width: {min: 640},
                    height: {min: 480},
                    facingMode: "environment",
                    aspectRatio: {min: 1, max: 2}
                }
            },
            locator: {
                patchSize: "medium",
                halfSample: true
            },
            numOfWorkers: 2,
            frequency: 10,
            decoder: {
                readers : [{
                    format: "ean_reader",
                    config: {}
                }]
            },
            locate: true
        },
        lastResult : null
    };

    App.init();

    Quagga.onProcessed(function(result) {
        var drawingCtx = Quagga.canvas.ctx.overlay,
            drawingCanvas = Quagga.canvas.dom.overlay;

        if (result) {
            if (result.boxes) {
                drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                result.boxes.filter(function (box) {
                    return box !== result.box;
                }).forEach(function (box) {
                    Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: "green", lineWidth: 2});
                });
            }

            if (result.box) {
                Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: "#00F", lineWidth: 2});
            }

            if (result.codeResult && result.codeResult.code) {
                Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3});
            }
        }
    });

    Quagga.onDetected(function(result) {
        var code = result.codeResult.code;
        console.log(code)
        Quagga.stop();
        selfVue.addProductByBarcode(code);
        // if (App.lastResult !== code) {
        //     App.lastResult = code;
        //     var $node = null, canvas = Quagga.canvas.dom.image;

        //     $node = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');
        //     $node.find("img").attr("src", canvas.toDataURL());
        //     $node.find("h4.code").html(code);
        //     $("#result_strip ul.thumbnails").prepend($node);
        // }
        });

    });

      },
      addProductByBarcode(barcode){
        let product = this.productsByBrand.filter(item => item.barcode == barcode)[0];
        this.productChange(product);
        this.item.productName = product.name
        this.scannerDialog = false;
      }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Buyers/Invoice/AddItem.vue